import { ServerDataGrid } from '@cmg/data-grid';
import { Stack } from '@cmg/design-system';

import { useSideBarDef } from '../../../hooks/useSideBarDef';
import { salesCoverageColumnDefs } from '../../columns';
import type { UnderwriterEmployeeFragment } from './graphql/__generated__';
import { INITIAL_SALES_COVERAGE_GRID_STATE, useDataSource } from './SalesCoverageGrid.model';

type SalesCoverageGridProps = Readonly<{
  tenantId?: string;
}>;

export function SalesCoverageGrid({ tenantId }: SalesCoverageGridProps) {
  const sideBar = useSideBarDef();
  const dataSource = useDataSource({ tenantId });

  return (
    <Stack direction="column" sx={{ height: '100%' }}>
      <ServerDataGrid<UnderwriterEmployeeFragment>
        serverSideDatasource={dataSource}
        columnDefs={salesCoverageColumnDefs}
        autoSizeStrategy={{
          type: 'fitGridWidth',
        }}
        sideBar={sideBar}
        initialState={INITIAL_SALES_COVERAGE_GRID_STATE}
      />
    </Stack>
  );
}

export default SalesCoverageGrid;
